import { SelectOption } from "../common/components/form/Select";
import {
    contractorProfileTypes,
    developerProfileTypes,
} from "../constants/profiles";
import { UserProfileType } from "../types/profile";

export const parseUserProfileTypeToText = (
    profileType: UserProfileType | string,
): string => {
    switch (profileType) {
        case UserProfileType.APPROVER:
            return "Approver";
        case UserProfileType.DEVELOPER:
            return "Developer";
        case UserProfileType.MAIN_CONTRACTOR:
            return "Service Provider";
        case UserProfileType.HSBC:
            return "HSBC";
        default:
            return "";
    }
};

export const getProfileTypeOptionsByNode = (
    isDeveloper: boolean,
): SelectOption[] => {
    return isDeveloper ? developerProfileTypes : contractorProfileTypes;
};
